import { Flex, forwardRef, Icon } from '@chakra-ui/react';
import React from 'react';
import { DataTestId } from 'types/general.types';
import { SystemStyleObject } from '@chakra-ui/styled-system';

interface MenuBarIconProps extends DataTestId {
  onClick?: () => void;
  tooltip?: string;
  disabled: boolean;
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  active?: boolean;
  sx?: SystemStyleObject;
}

export const MenuBarIcon = forwardRef<MenuBarIconProps, 'div'>(
  (
    { onClick, icon, tooltip, disabled, active, sx, 'data-testid': dataTestId },
    ref
  ) => {
    return (
      <Flex
        ref={ref}
        as="button"
        align="center"
        justify="center"
        onClick={onClick}
        disabled={disabled || !onClick}
        width={4}
        height={4}
        borderRadius="4px"
        bg={active ? 'M.30' : undefined}
        _hover={{
          svg: {
            color: 'M.70',
          },
        }}
        _disabled={{
          svg: {
            color: 'textDisabled',
          },
          cursor: 'default !important',
        }}
        sx={sx}
        data-testid={dataTestId}
        title={tooltip}
      >
        <Icon
          as={icon}
          color={active ? 'M.70' : 'M.60'}
          width="inherit"
          height="inherit"
        />
      </Flex>
    );
  }
);
